import $ from 'jquery';
import throttle from 'utils/throttle';

const backToTopInit = () => {
    const $component = $('.c-back-to-top');
    const visibleClass = 'is-visible';
    const minVisibleDistance = 1000; // in px
    const scrollThrottle = 200; // in ms
    const scrollSpeed = 'slow';

    if ($component.length) {
        // scroll to top
        $component.click(e => {
            e.preventDefault();
            $('html, body').animate({ scrollTop: 0 }, scrollSpeed);
        });

        // throttle the check of document top postition compared to the minimum visible distance from page top every 200ms
        const scrollUp = throttle(() => {
            if ($(document).scrollTop() > minVisibleDistance) {
                $component.addClass(visibleClass);
            } else {
                $component.removeClass(visibleClass);
            }
        }, scrollThrottle);

        $(window).on('scroll', scrollUp);
    }
};

// doc ready
$(() => {
    backToTopInit();
});
